import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PostPropertyComponent } from './components/vendor/post-property/post-property.component';
import { ForgotpasswordComponent } from './shared/components/forgotpassword/forgotpassword.component';
import { VendorDashboardComponent } from './components/vendor/vendor-dashboard/vendor-dashboard.component';
import { LoanComponent } from './components/vendor/loan/loan.component';
import { AuthGuard } from './common/guards/auth-guard';
import { MyPropertiesComponent } from './components/vendor/my-properties/my-properties.component';
import { MyProjectsComponent } from './components/vendor/my-projects/my-projects.component';
import { AddCompanyComponent } from './components/companies/add-company/add-company.component';
import { CompanySidebarComponent } from './components/companies/company-sidebar/company-sidebar.component';
import { CompanyinfoComponent } from './components/companies/companyinfo/companyinfo.component';
import { CompanyProfileComponent } from './components/companies/company-profile/company-profile.component';
import { AddProjectComponent } from './components/projects/add-project/add-project.component';
import { MyLeadsComponent } from './components/vendor/my-leads/my-leads.component';
import { MyviewLeadsComponent } from './components/myview-leads/myview-leads.component';
import { MyCompanyComponent } from './components/my-company/my-company.component';
import { UnitsComponent } from './components/projects/units/units.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { LoginComponent } from './components/login/login.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { NexusnetworkComponent } from './components/nexusnetwork/nexusnetwork.component';
import { SupportComponent } from './components/support/support.component';
import { MyTeamsComponent } from './my-teams/my-teams.component';
import { CrmComponent } from './components/crm/crm.component';
import { SalesComponent } from './components/sales/sales.component';



const routes: Routes = [


  {
    path: 'post-property/:propertyName',
    canActivate: [AuthGuard],
    component: PostPropertyComponent
  },
  {
    path: '',
    component: VendorDashboardComponent
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    component: VendorDashboardComponent
  },
  {
    path: 'myProperties',
    canActivate: [AuthGuard],
    component: MyPropertiesComponent
  },
  {
    path: 'myProjects',
    component: MyProjectsComponent
  },
  {
    path: 'unit',
    component: UnitsComponent
  },
  {
    path: 'addCompany/:companyName',
    canActivate: [AuthGuard],
    component: AddCompanyComponent
  },
  {
    path: 'addProject/:propertyId',
    canActivate: [AuthGuard],
    component: AddProjectComponent
  },
  {
    path: 'companyInfo',
    canActivate: [AuthGuard],
    component: CompanyinfoComponent
  },

  {
    path: 'companyInfo',
    canActivate: [AuthGuard],
    component: CompanyinfoComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'myLead',
    canActivate: [AuthGuard],
    component: MyLeadsComponent
  },

  {
    path: 'myViewLead',
    canActivate: [AuthGuard],
    component: MyviewLeadsComponent
  },
  {
    path: 'myCompany',
    component: MyCompanyComponent
  },
  {
    path: 'myTeams',
     canActivate: [AuthGuard],
    component: MyTeamsComponent
  },
  {
    path: 'crm',
    canActivate: [AuthGuard],
    component: CrmComponent
  },
  {
    path: 'sales',
    canActivate: [AuthGuard],
    component: SalesComponent
  },
  {
    path: 'nexus-Network',
    canActivate: [AuthGuard],
    component: NexusnetworkComponent
  },
  {
    path: 'Support&Help',
    canActivate: [AuthGuard],
    component: SupportComponent
  },
  {
    path: 'companyProfile',
    canActivate: [AuthGuard],
    component: CompanyProfileComponent
  },
  {
    path: 'loan',
    canActivate: [AuthGuard],
    component: LoanComponent
  },

  {
    path: 'forgotpassword',
    canActivate: [AuthGuard],
    component: ForgotpasswordComponent
  },
  {
    path: "myProfile",
    canActivate: [AuthGuard],
    component: MyProfileComponent
  },
  {
    path: "changePassword",
    canActivate: [AuthGuard],
    component: ChangePasswordComponent
  },
  {
    path: 'leadUpload',
    canActivate: [AuthGuard],
    loadChildren: () => import('./lead-upload/lead-upload.module').then(m => m.LeadUploadModule)
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
